var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.canExecuteWebCustomerService)?_c('web-customer-service-tool',{attrs:{"userAttribute":_vm.userAttribute,"cartTotalPrice":_vm.cartTotalPrice}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }